import { render, staticRenderFns } from "./SalesTactics.vue?vue&type=template&id=3e765f66&scoped=true&"
import script from "./SalesTactics.vue?vue&type=script&lang=js&"
export * from "./SalesTactics.vue?vue&type=script&lang=js&"
import style0 from "./SalesTactics.vue?vue&type=style&index=0&id=3e765f66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e765f66",
  null
  
)

export default component.exports